'use es6';

import { Record } from 'immutable';
export default new Record({
  entity: null,
  trackingStatus: null
});